import h from "../draggable/index.js";
import m from "../assets/utils/scrollbar-width.js";
import { resolveComponent as u, openBlock as d, createElementBlock as b, normalizeClass as n, createElementVNode as o, normalizeStyle as i, renderSlot as p, createCommentVNode as w, createVNode as _, withCtx as f } from "vue";
import { _ as g } from "../_plugin-vue_export-helper-dad06003.js";
import { w as v } from "../util-b2b0dc25.js";
const B = {
  name: "rScrollBar",
  components: { Draggable: h },
  props: {
    /**
     * 类型
     */
    wrapperClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      scrollBarHeight: 0,
      scrollBarTranslateTop: 0,
      needShowBar: !0,
      mousedownState: !1,
      mouseenterState: !1,
      barWidth: 6
    };
  },
  computed: {
    barShow() {
      return this.needShowBar && (this.mouseenterState || this.mousedownState);
    },
    barThumbWidth() {
      const s = this.barWidth - 6;
      return s <= 0 ? 6 : s;
    }
  },
  methods: {
    mousedown() {
      this.mousedownState = !0, this.mouseupCallBack || (this.mouseupCallBack = this.mouseup.bind(this), document.addEventListener("mouseup", this.mouseupCallBack));
    },
    mouseup() {
      this.mousedownState = !1;
    },
    mouseenter() {
      this.mouseenterState = !0, this.initScrollBarState();
    },
    mouseleave() {
      this.mouseenterState = !1;
    },
    moveChange(s) {
      let { top: r } = s;
      r < 0 && (r = 0), r > this.$refs.scrollbar_wrap.clientHeight - this.scrollBarHeight && (r = this.$refs.scrollbar_wrap.clientHeight - this.scrollBarHeight);
      const l = r / (this.$refs.scrollbar_wrap.clientHeight - this.scrollBarHeight) * (this.$refs.scrollbar_wrap.scrollHeight - this.$refs.scrollbar_wrap.clientHeight);
      return this.$refs.scrollbar_wrap.scrollTop = l, {
        left: 0,
        top: r
      };
    },
    scrollEvent() {
      const s = this.$refs.scrollbar_wrap.scrollTop / (this.$refs.scrollbar_wrap.scrollHeight - this.$refs.scrollbar_wrap.clientHeight) * (this.$refs.scrollbar_wrap.clientHeight - this.scrollBarHeight);
      this.scrollBarTranslateTop = s;
    },
    initScrollBarState() {
      this.scrollBarHeight = this.$refs.scrollbar_wrap.clientHeight / this.$refs.scrollbar_wrap.scrollHeight * this.$refs.scrollbar_wrap.clientHeight, this.setNeedShowBar();
    },
    setNeedShowBar() {
      this.needShowBar = this.$refs.scrollbar_wrap.clientHeight !== this.$refs.scrollbar_wrap.scrollHeight;
    }
  },
  mounted() {
    setTimeout(() => {
      this.initScrollBarState();
    }), this.resizeCallBack = this.initScrollBarState.bind(this), window.addEventListener("resize", this.resizeCallBack);
    const s = m();
    this.barWidth = s;
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeCallBack), this.mouseupCallBack && document.removeEventListener("mouseup", this.mouseupCallBack);
  }
}, S = { class: "r-scrollbar__view" };
function H(s, r, l, T, a, e) {
  const c = u("Draggable");
  return d(), b(
    "div",
    {
      class: n(["r-scrollbar", {
        [l.wrapperClass]: l.wrapperClass
      }]),
      onMouseenter: r[2] || (r[2] = (...t) => e.mouseenter && e.mouseenter(...t)),
      onMouseleave: r[3] || (r[3] = (...t) => e.mouseleave && e.mouseleave(...t))
    },
    [
      o(
        "div",
        {
          class: "r-scrollbar__wrap",
          style: i({ marginRight: `-${a.barWidth}px` }),
          onScroll: r[0] || (r[0] = (...t) => e.scrollEvent && e.scrollEvent(...t)),
          ref: "scrollbar_wrap"
        },
        [
          o("div", S, [
            p(s.$slots, "default")
          ])
        ],
        36
        /* STYLE, HYDRATE_EVENTS */
      ),
      w(` <div class="r-scrollbar__bar is-horizontal">
      <div class="r-scrollbar__thumb" ref="scrollbar_horizontal"></div>
    </div>`),
      o(
        "div",
        {
          class: n(["r-scrollbar__bar is-vertical", { "r-scrollbar__bar__show": e.barShow }]),
          style: i({
            width: `${a.barWidth}px`
          })
        },
        [
          _(c, {
            moveChange: e.moveChange,
            translateX: 0,
            translateY: a.scrollBarTranslateTop
          }, {
            dragBar: f(() => [
              o(
                "div",
                {
                  class: "r-scrollbar__thumb",
                  ref: "scrollbar_vertical",
                  style: i({
                    height: `${a.scrollBarHeight}px`,
                    width: `${e.barThumbWidth}px`
                  }),
                  onMousedown: r[1] || (r[1] = (...t) => e.mousedown && e.mousedown(...t))
                },
                null,
                36
                /* STYLE, HYDRATE_EVENTS */
              )
            ]),
            _: 1
            /* STABLE */
          }, 8, ["moveChange", "translateY"])
        ],
        6
        /* CLASS, STYLE */
      )
    ],
    34
    /* CLASS, HYDRATE_EVENTS */
  );
}
const C = /* @__PURE__ */ g(B, [["render", H], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/scroll-bar/scroll-bar.vue"]]), $ = v(C);
export {
  $ as default
};
